import React from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";
import SideTableNotifications from "./SideTableNotifications";

const ViewNotifications = () => {
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <SideTableNotifications from={"CA_ADMIN"} />
    </CaSideNav>
  );
};

export default ViewNotifications;
